export enum Environment {
  Dev = 'dev',
  Rec = 'rec',
  Oat = 'oat',
  Pro = 'pro',
  Test = 'test',
}
